import React, { useEffect, useState } from "react";
const API_URL = process.env.REACT_APP_API_URL;

export default function RateTeacher() {
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");

  // ✅ Corrected API URL
  useEffect(() => {
    fetch(`${API_URL}/api/teacher/teachers`)
      .then((res) => res.json())
      .then((data) => setTeachers(data))
      .catch((err) => {
        console.error("Error fetching teachers:", err);
        setMessage("Failed to load teachers.");
      });
  }, []);

  const handleSubmit = async (e) => {
  e.preventDefault();
  setMessage("");

  if (!selectedTeacher || rating === 0 || comment.trim() === "") {
    setMessage("Please fill out all fields.");
    return;
  }

  const token = localStorage.getItem("token"); // ⬅️ Get the token from localStorage

  if (!token) {
    setMessage("❌ You must be logged in to rate a teacher.");
    return;
  }

  try {
    const res = await fetch(`${API_URL}/api/student/rate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`, // ⬅️ Include token here
      },
      body: JSON.stringify({
        teacherId: selectedTeacher,
        rating,
        comment,
      }),
    });

    const data = await res.json();
    if (!res.ok) {
      setMessage(data.error || "Failed to submit rating.");
    } else {
      setMessage("✅ Rating submitted successfully!");
      setRating(0);
      setComment("");
      setSelectedTeacher("");
    }
  } catch (error) {
    console.error("Submit error:", error);
    setMessage("❌ Server error. Try again later.");
  }
};
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-2xl mx-auto bg-white shadow-lg p-8 rounded-xl">
        <h2 className="text-2xl font-bold mb-6 text-purple-700">⭐ Rate a Teacher</h2>

        {message && (
          <p className="mb-4 text-center bg-purple-100 text-purple-800 py-2 px-4 rounded-md">
            {message}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Teacher Dropdown */}
          <div>
            <label className="block font-semibold mb-1">Select Teacher</label>
            <select
              value={selectedTeacher}
              onChange={(e) => setSelectedTeacher(e.target.value)}
              className="w-full border p-3 rounded"
              required
            >
              <option value="">-- Choose --</option>
              {teachers.map((teacher) => (
                <option key={teacher._id} value={teacher._id}>
                  {teacher.name}
                </option>
              ))}
            </select>
          </div>

          {/* Star Rating */}
          <div>
            <label className="block font-semibold mb-1">Rating</label>
            <div className="flex space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  onClick={() => setRating(star)}
                  className={`text-2xl focus:outline-none ${
                    rating >= star ? "text-yellow-500" : "text-gray-400"
                  }`}
                  aria-label={`Rate ${star} star`}
                >
                  ★
                </button>
              ))}
            </div>
          </div>

          {/* Comment */}
          <div>
            <label className="block font-semibold mb-1">Comment</label>
            <textarea
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              rows="4"
              className="w-full border p-3 rounded"
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-purple-600 text-white font-bold py-3 rounded-lg hover:bg-purple-700"
          >
            Submit Rating
          </button>
        </form>
      </div>
    </div>
  );
}
